import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import {
  Page,
  Content,
  ContentContainer,
} from 'layout/styles/PageLayout.style';

export const FormPage = styled(Page)``;

export const FormContentContainer = styled(ContentContainer)`
  &::after {
    content: '';
    display: block;
    min-height: 30px;
    flex-shrink: 0;
  }
`;

export const FormContent = styled(Content)`
  height: auto;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 0 15px 20px;
  }
`;

export const EmbeddedContent = styled(Content)`
  max-width: 600px;

  @media (max-width: ${breakpoints.laptop}) {
    max-width: none;
  }

  @media (max-width: ${breakpoints.tablet}) {
    padding: 0 15px 20px;
  }
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`;
